import MediaForm from '@Components/MediaForm';
import { MediaContextProvider } from '../../context/mediaContext/mediaContext';

export default function Upload() {
	return (
		<MediaContextProvider>
			<MediaForm />
		</MediaContextProvider>
	);
}